import { IBudgetActionFilterRequest } from '../../../../model/sge/budget-action/request/budget-action-filter-request';
import { IBudgetActionResponse } from '../../../../model/sge/budget-action/response/budget-action-response';
import { IBudgetProgramResponse } from '../../../../model/sge/budget-program/response/budget-program-response';
import { IBudgetUnitResponse } from '../../../../model/sge/budget-unit/response/budget-unit-response';

export type BudgetActionSearchState = {
    parameters: IBudgetActionFilterRequest;
    budgetPrograms: IBudgetProgramResponse[];
    budgetUnits: IBudgetUnitResponse[];
    searchTrigger: number;
    // A unidade orçamentária vem do programa da ação e só é usada para preencher a cascata na edição
    drawer: { open: boolean; record?: IBudgetActionResponse; budgetUnitId?: number };
};

export enum ACTION_TYPES {
    updateParameter = 'updateParameter',
    setLookups = 'setLookups',
    triggerSearch = 'triggerSearch',
    openDrawer = 'openDrawer',
    closeDrawer = 'closeDrawer',
}

export const BudgetActionSearchReducer = (state: BudgetActionSearchState, action: any): BudgetActionSearchState => {
    const { type, payload } = action;
    switch (type) {
        case ACTION_TYPES.updateParameter:
            return { ...state, parameters: { ...state.parameters, ...payload } };
        case ACTION_TYPES.setLookups:
            return { ...state, ...payload };
        case ACTION_TYPES.triggerSearch:
            return { ...state, searchTrigger: state.searchTrigger + 1 };
        case ACTION_TYPES.openDrawer:
            return { ...state, drawer: { open: true, record: payload?.record, budgetUnitId: payload?.budgetUnitId } };
        case ACTION_TYPES.closeDrawer:
            return { ...state, drawer: { open: false } };
        default:
            throw new Error(`Unhandled action type: ${type}`);
    }
};
